import axiosApi from '@mint-lib/api';

import { objectKeysToSnakeCase } from '@myn/shared/src/utils';

import {
  BlobResponse,
  Co2OrdersReq,
  GetCo2OrdersRes,
  OffsetSubordersMeta,
} from '../types/co2notifications.js';
import { apiSlice } from './apiSlice.js';

export const cO2ApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCo2Orders: builder.query<GetCo2OrdersRes, Co2OrdersReq>({
      query: (options) => ({
        url: 'offset_suborders/',
        params: objectKeysToSnakeCase(options),
      }),
    }),
    getCo2OrdersMeta: builder.query<OffsetSubordersMeta, void>({
      query: () => ({ url: 'offset_suborders/meta/' }),
    }),
    acceptCo2Order: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `offset_suborders/${id}/accept/`,
        method: 'PATCH',
      }),
    }),
    rejectCo2Order: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `offset_suborders/${id}/reject/`,
        method: 'PATCH',
      }),
    }),
    downloadCo2Certificate: builder.query<BlobResponse, { id: number }>({
      queryFn: async ({ id }) => {
        const res = await axiosApi.request({
          url: `offset_suborders/${id}/download_certificate/`,
          method: 'GET',
          headers: {
            'Content-Type': 'application/pdf',
          },
          responseType: 'blob',
          baseURL: '/api/datintell/v1/',
        });
        return {
          data: {
            blob: res.request.response as Blob,
            fileName:
              res.headers['content-disposition']?.split('filename=')?.[1] ||
              'certificate',
          },
        };
      },
    }),
  }),
});

export const {
  useGetCo2OrdersQuery,
  useGetCo2OrdersMetaQuery,
  useLazyDownloadCo2CertificateQuery,
  useAcceptCo2OrderMutation,
  useRejectCo2OrderMutation,
} = cO2ApiSlice;
